module.exports = __webpack_public_path__ + "img/A58A0050.655ce7c4.jpg";